import { Alert, Col, Form, Row } from 'react-bootstrap';
import { ButtonContainer, StyledButton } from '../../StyledComponets';
import {
  allowDecimalNumbers,
  allowOnlyNumbers,
  contactType,
} from '../constant';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import {
  CNT_KEY,
  formatPhoneNumber,
  getInitialValues,
  getValidationSchema,
} from './helpers';
import { useEffect, useState } from 'react';
import {
  fetchCityState,
  getCityStateByZip,
  resetCityStateReducer,
} from '../../app/contact/contactSlice';
import {
  fetchCustomerData,
  getCustomerData,
  isCustomerDataLoaded,
  resetCustomerDataReducer,
} from '../../app/contact/getCustomerSlice';
import { useDispatch, useSelector } from 'react-redux';
import ConfirmCustomer from './CustomerVerify';
import MapLocation from './MapLocation';
import ShowPendingEnrollemnt from './ShowPendingEnrollement';
import { getUserData } from '../../app/environment/userSlice';
import {
  fetchCoordinateData,
  getCoordinateData,
} from '../../app/contact/coOrdSlice';
import ServerErrorPopup from './ServerError';
import ContactModal from './ContactModal';

export default function ContactForm(props) {
  const { type, setSection, pageType, isProjectDetailsView } = props;
  const [disableFields, setDisableFileds] = useState(false);
  const [showCommonForm, setShowCommonForm] = useState(props?.showCommonForm);
  const [showMap, setShowMap] = useState(false);
  const [showLatError, setShowLatError] = useState(false);
  const [confirmCustomer, setConfirmCustomer] = useState(false);
  const [havePendingEnroll, setHavePendingEnroll] = useState(false);
  const [showServerError, setShowserverError] = useState(false);
  const [showContactModal, setShowContactModal] = useState({ show: false });
  const [otherContactData, setOtherContactData] = useState({});

  const isView = pageType === 'view';
  const isEdit = pageType === 'edit';

  const {
    register,
    watch,
    handleSubmit,
    setValue,
    getValues,
    setError,
    clearErrors,
    formState: { errors, isValid, dirtyFields },
  } = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
    resolver: yupResolver(getValidationSchema(props.type)),
    defaultValues:
      props.formData?.data ||
      getInitialValues(
        props.showPosition,
        props.showAccount,
        props.showCommonForm
      ),
  });
  const dispatch = useDispatch();
  const cityState = useSelector(getCityStateByZip);
  const customerData = useSelector(getCustomerData);
  const isCASLoaded = useSelector(isCustomerDataLoaded);
  const coOrdData = useSelector(getCoordinateData);
  const userData = useSelector(getUserData);

  const noPosError =
    !errors[CNT_KEY.LAT] &&
    !errors[CNT_KEY.LONG] &&
    getValues(CNT_KEY.LAT) &&
    getValues(CNT_KEY.LONG) &&
    getValues(CNT_KEY.VALIDPOS);

  const renderError = (key) =>
    errors?.[key]?.message && (
      <Form.Control.Feedback type="invalid">
        {errors?.[key]?.message}
      </Form.Control.Feedback>
    );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (
      userData &&
      type == contactType.applicant &&
      !userData?.profile?.AzureAD_IDPUser
    ) {
      setValue(CNT_KEY.EMAIL, userData?.profile?.email);
      setValue(CNT_KEY.FNAME, userData?.profile?.firstName);
      setValue(CNT_KEY.LNAME, userData?.profile?.lastName);
      setValue(CNT_KEY.CPNAME, userData?.profile?.companyName);
      setValue(CNT_KEY.STATE, userData?.profile?.state);
      setValue(CNT_KEY.CITY, userData?.profile?.city);
      setValue(CNT_KEY.ZIP, userData?.profile?.zipCode);
      setValue(CNT_KEY.ADD1, userData?.profile?.streetAddress);
      setValue(CNT_KEY.ADD2, userData?.profile?.streetAddress2);
      setValue(CNT_KEY.MOBILE, userData?.profile?.mobilePhone);
    }
  }, [userData]);

  useEffect(() => {
    if (getValues(CNT_KEY.ZIP)?.length === 5) {
      if (cityState?.validZip) {
        setValue(CNT_KEY.VALIDZIP, true);
        setValue(CNT_KEY.STATE, cityState?.state);
        setValue(CNT_KEY.CITY, cityState?.city);
        clearErrors([
          CNT_KEY.ZIP,
          CNT_KEY.VALIDZIP,
          CNT_KEY.STATE,
          CNT_KEY.CITY,
        ]);
      } else {
        setValue(CNT_KEY.VALIDZIP, false);
        cityState && setError(CNT_KEY.ZIP, { message: 'Enter valid zip' });
        setValue(CNT_KEY.STATE, '');
        setValue(CNT_KEY.CITY, '');
      }
    }
  }, [cityState]);

  useEffect(() => {
    if (props.showAccount) {
      if (customerData?.accountNb) {
        setValue(CNT_KEY.VALIDCON, true);
        clearErrors([CNT_KEY.CONID, CNT_KEY.VALIDCON]);
      } else if (customerData === 'Customer Not Found') {
        setValue(CNT_KEY.VALIDCON, false);

        setError(CNT_KEY.CONID, { message: `Enter valid ${sType}` });
        setValue(CNT_KEY.VALIDCON, false);
      } else if (isCASLoaded && !customerData) {
        setShowserverError(true);
        setValue(CNT_KEY.VALIDCON, false);
      } else {
        setShowserverError(false);
        setValue(CNT_KEY.VALIDCON, true);
      }
    }
  }, [customerData, isCASLoaded]);

  useEffect(() => {
    if (props.showPosition) {
      if (coOrdData?.companyCodeOwner) {
        setValue(CNT_KEY.VALIDPOS, true);
        clearErrors([CNT_KEY.LAT, CNT_KEY.LONG, CNT_KEY.VALIDPOS]);
      } else if (coOrdData === 'Invalid Latitude and Longitude') {
        setShowLatError(true);
        setValue(CNT_KEY.VALIDPOS, false);
      } else setValue(CNT_KEY.VALIDPOS, false);
    }
  }, [coOrdData]);

  const submitForm = (data) => {
    setSection(true, data);
  };

  const saveOtrContact = (data) => {
    setOtherContactData({ ...otherContactData, [showContactModal.type]: data });
    setShowContactModal({ show: false });
  };

  const haveConnection = watch(CNT_KEY.HVCONN, 'yes');
  const connectionType = watch(CNT_KEY.CONTYPE, 'accNo');
  const sameAsPrevious = watch(CNT_KEY.SAME_CD, false);

  const sType =
    getValues(CNT_KEY.CONTYPE) === 'accNo' ? 'account number' : 'EZ id';

  const cusErr = `Unable to validate ${sType}: ${getValues(CNT_KEY.CONID)}`;

  useEffect(() => {
    if (type === contactType.customer) {
      if (haveConnection == 'no') {
        resetCustomer();
        setShowCommonForm(false);
      } else {
        setShowCommonForm(true);
      }
    }
    if (type === contactType.service && haveConnection == 'no') {
      resetCustomer();
    }
  }, [haveConnection]);

  useEffect(() => {
    if (sameAsPrevious) {
      props.setPreviousData(type === contactType.applicant);
    } else {
      props.setPreviousData &&
        updateForm(
          getInitialValues(
            props.showPosition,
            props.showAccount,
            props.showCommonForm
          ),
          {}
        );
    }
  }, [sameAsPrevious]);

  useEffect(() => {
    if (props.formData?.data) {
      updateForm(props.formData?.data, {
        shouldValidate: disableFields,
      });
    }
  }, [props.formData]);

  const updateForm = (data, validateObj) => {
    for (const [key, value] of Object.entries(data)) {
      setValue(key, value, validateObj);
    }
  };

  //API Call
  const validateLatLong = () => {
    if (
      !errors[CNT_KEY.LAT] &&
      !errors[CNT_KEY.LONG] &&
      getValues(CNT_KEY.LAT) &&
      getValues(CNT_KEY.LONG)
    ) {
      const reqObj = {
        Latitiude: getValues(CNT_KEY.LAT),
        Longitude: getValues(CNT_KEY.LONG),
      };
      dispatch(fetchCoordinateData(reqObj));
    }
  };

  const onLatLongBlur = (e) => {
    validateLatLong();
  };

  const latField = register(CNT_KEY.LAT);
  const onLatChange = (e) => {
    showMap && setShowMap(false);
    e.target.value = allowDecimalNumbers(e.target.value);
    latField.onChange(e);
  };

  const longField = register(CNT_KEY.LONG);
  const onLongChange = (e) => {
    showMap && setShowMap(false);
    e.target.value = allowDecimalNumbers(e.target.value);
    longField.onChange(e);
  };

  const mobileField = register(CNT_KEY.MOBILE, { required: true });
  const onMobileChange = (e) => {
    const value = allowOnlyNumbers(e.target.value);
    e.target.value = formatPhoneNumber(value);
    mobileField.onChange(e);
  };

  const zipField = register(CNT_KEY.ZIP, { required: true });
  const onZipChange = (e) => {
    const value = e.target.value;
    e.target.value = allowOnlyNumbers(value);
    if (e.target.value.length < 5) {
      setValue(CNT_KEY.VALIDZIP, true);
      clearErrors([CNT_KEY.VALIDZIP]);
    } else {
      onZipBlur(e);
    }
    setValue(CNT_KEY.STATE, '');
    setValue(CNT_KEY.CITY, '');
    zipField.onChange(e);
  };

  const onZipBlur = (e) => {
    if (e.target.value.length === 5) {
      dispatch(fetchCityState(e.target.value));
    }
  };

  const conIdField = register(CNT_KEY.CONID);

  const onConIdChange = (e) => {
    const value = e.target.value;
    e.target.value = allowOnlyNumbers(value);
    const conType = getValues(CNT_KEY.CONTYPE);
    const validLn = conType === 'accNo' ? 10 : 17;
    if (e.target.value.length < validLn) {
      setValue(CNT_KEY.VALIDCON, true);
      clearErrors([CNT_KEY.VALIDCON]);
    } else {
      onConIdBlur(e);
    }
    conIdField.onChange(e);
  };

  const resetCustomer = () => {
    dispatch(resetCustomerDataReducer());
    setValue(CNT_KEY.CONID, '');
    setValue(CNT_KEY.VALIDCON, false);
  };

  const resetCommonFields = () => {
    setValue(CNT_KEY.EMAIL, '');
    setValue(CNT_KEY.FNAME, '');
    setValue(CNT_KEY.LNAME, '');
    setValue(CNT_KEY.CPNAME, '');
    setValue(CNT_KEY.STATE, '');
    setValue(CNT_KEY.CITY, '');
    setValue(CNT_KEY.ZIP, '');
    setValue(CNT_KEY.ADD1, '');
    setValue(CNT_KEY.ADD2, '');
    setValue(CNT_KEY.MOBILE, '');
  };

  const resetContactDetails = () => {
    resetCommonFields();
    //Reset addtional fields
    setValue(CNT_KEY.CONID, '');
    setValue(CNT_KEY.VALIDCON, true);
    setValue(CNT_KEY.CONTYPE, 'accNo');
    setValue(CNT_KEY.LAT, '');
    setValue(CNT_KEY.LONG, '');
    setValue(CNT_KEY.VALIDPOS, true);
  };

  const onConIdBlur = (e) => {
    const conType = getValues(CNT_KEY.CONTYPE);
    const validLn = conType === 'accNo' ? 10 : 17;
    if (e.target.value.length === validLn) {
      dispatch(
        fetchCustomerData({
          AccountNb: conType === 'accNo' ? e.target.value : '',
          EZId: conType !== 'accNo' ? e.target.value : '',
        })
      );
      setConfirmCustomer(true);
    } else {
      setConfirmCustomer(false);
    }
  };

  const conTypeField = register(CNT_KEY.CONTYPE);
  const haveAEPConField = register(CNT_KEY.HVCONN);
  const haveDEROwnerField = register(CNT_KEY.DEROWNERFLAG);
  const haveSecCustField = register(CNT_KEY.SECCUSTFLAG);
  const havePOIOwnerField = register(CNT_KEY.POIOWNERFLAG);
  const haveInsElecField = register(CNT_KEY.INSPELECFLAG)


  const onConTypeChange = (e) => {
    if (type === contactType.customer || type === contactType.service) {
      setValue(CNT_KEY.CONID, '');
      setValue(CNT_KEY.VALIDCON, true);
      clearErrors([CNT_KEY.VALIDCON, CNT_KEY.CONID]);
    }
    conIdField.onChange(e);
  };

  const onAEPConChange = (e) => {
    if (type === contactType.customer || type === contactType.service) {
      resetContactDetails();
    }
    haveAEPConField.onChange(e);
  };

  const onDerOwnerChange = (e) => {
    if (e.target.checked) {
      setShowContactModal({
        show: true,
        type: contactType.derOwner,
        mode: 'create',
        data: {},
      });
    } else {
      resetModalField(true,contactType.derOwner);
    }
    haveDEROwnerField.onChange(e);
  };

  
  const onPoiOwnerChange = (e) => {
    if (e.target.checked) {
      setShowContactModal({
        show: true,
        type: contactType.poiOwner,
        mode: 'create',
        data: {},
      });
    } else {
      resetModalField(true,contactType.poiOwner);
    }
    havePOIOwnerField.onChange(e);
  };

  const onInsElecChange = (e) => {
    if (e.target.checked) {
      setShowContactModal({
        show: true,
        type: contactType.insElect,
        mode: 'create',
        data: {},
      });
    } else {
      resetModalField(true,contactType.insElect);
    }
    haveInsElecField.onChange(e);
  };

  const onSecCustChange = (e) => {
    if (e.target.checked) {
      setShowContactModal({
        show: true,
        type: contactType.secCust,
        mode: 'create',
        data: {},
      });
    } else {
      resetModalField(true,contactType.secCust);
    }
    haveSecCustField.onChange(e);
  };

  const resetModalField = (checkBoxFlag,fieldName) => { 
      if (checkBoxFlag || !otherContactData?.[fieldName || showContactModal.type]) {
        setValue(fieldName || showContactModal.type, false);
        setOtherContactData({
          ...otherContactData,
          [fieldName || showContactModal.type]: null,
        });
      }    
  };

  const onViewAtMap = () => {
    if (noPosError) {
      setShowMap(true);
    } else {
      setShowMap(false);
    }
  };

  const renderAddressForm = (add1, add2, st, city, zip) => (
    <>
      <Row>
        <Col>
          <Form.Group controlId="addr1">
            <Form.Text size="sm" style={{ margin: '2px' }}>
              Address Line1
            </Form.Text>
            <Form.Control
              {...register(add1)}
              type="text"
              placeholder="Enter Address Line1"
              maxLength="100"
              isInvalid={errors[add1]}
              disabled={disableFields || isView}
            />
            {renderError(add1)}
          </Form.Group>
        </Col>
        <Col>
          <Form.Group controlId="addr2">
            <Form.Text size="sm" style={{ margin: '2px' }}>
              Address Line2 (optional)
            </Form.Text>
            <Form.Control
              {...register(add2)}
              type="text"
              placeholder="Enter Address Line2"
              maxLength="100"
              isInvalid={errors[add2]}
              disabled={disableFields || isView}
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col>
          <Form.Group controlId="city">
            <Form.Text size="sm" style={{ margin: '2px' }}>
              City
            </Form.Text>
            <Form.Control
              {...register(city)}
              type="text"
              placeholder="Enter City"
              disabled={true}
              isInvalid={errors[city]}
            />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group controlId="state">
            <Form.Text size="sm" style={{ margin: '2px' }}>
              State
            </Form.Text>
            <Form.Control
              {...register(st)}
              type="text"
              placeholder="Enter State"
              disabled={true}
              isInvalid={errors[st]}
            />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group controlId="zip">
            <Form.Text size="sm" style={{ margin: '2px' }}>
              Zip
            </Form.Text>
            <Form.Control
              {...zipField}
              type="text"
              maxLength="5"
              autoComplete="nope"
              placeholder="Enter Zipcode"
              onChange={onZipChange}
              isInvalid={errors[zip]}
              disabled={disableFields || isView}
            />
            {renderError(zip)}
          </Form.Group>
        </Col>
      </Row>
    </>
  );

  const renderCommonForm = () => (
    <>
      <Row>
        <Col>
          <Form.Group controlId="firstname">
            <Form.Text size="sm" style={{ margin: '2px' }}>
              First Name
            </Form.Text>
            <Form.Control
              {...register(CNT_KEY.FNAME)}
              type="text"
              placeholder="First name"
              maxLength="100"
              isInvalid={errors[CNT_KEY.FNAME]}
              disabled={disableFields || isView}
            />
            {renderError(CNT_KEY.FNAME)}
          </Form.Group>
        </Col>
        <Col>
          <Form.Group controlId="lastname">
            <Form.Text size="sm" style={{ margin: '2px' }}>
              Last Name
            </Form.Text>
            <Form.Control
              {...register(CNT_KEY.LNAME)}
              type="text"
              placeholder="Last name"
              maxLength="100"
              isInvalid={errors[CNT_KEY.LNAME]}
              disabled={disableFields || isView}
            />
            {renderError(CNT_KEY.LNAME)}
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Form.Group controlId="companyName">
          <Form.Text size="sm" style={{ margin: '2px' }}>
            Company Name {type !== contactType.installer ? `(optional)` : ``}
          </Form.Text>
          <Form.Control
            {...register(CNT_KEY.CPNAME)}
            type="text"
            placeholder="Company name"
            maxLength="100"
            isInvalid={errors[CNT_KEY.CPNAME]}
            disabled={disableFields || isView}
          />
          {renderError(CNT_KEY.CPNAME)}
        </Form.Group>
      </Row>
      <Row>
        <Col>
          {' '}
          <Form.Group controlId="email">
            <Form.Text size="sm" style={{ margin: '2px' }}>
              Email
            </Form.Text>
            <Form.Control
              {...register(CNT_KEY.EMAIL)}
              type="text"
              placeholder="Email id"
              maxLength="100"
              isInvalid={errors[CNT_KEY.EMAIL]}
              disabled={disableFields || isView}
            />
            {renderError(CNT_KEY.EMAIL)}
          </Form.Group>
        </Col>
        <Col>
          <Form.Group controlId="mbl">
            <Form.Text size="sm" style={{ margin: '2px' }}>
              Mobile No
            </Form.Text>
            <Form.Control
              {...mobileField}
              type="text"
              placeholder="Mobile number"
              autoComplete="nope"
              maxLength={14}
              isInvalid={errors[CNT_KEY.MOBILE]}
              onChange={onMobileChange}
              disabled={disableFields || isView}
            />
            {renderError(CNT_KEY.MOBILE)}
          </Form.Group>{' '}
        </Col>
      </Row>
      {renderAddressForm(
        CNT_KEY.ADD1,
        CNT_KEY.ADD2,
        CNT_KEY.STATE,
        CNT_KEY.CITY,
        CNT_KEY.ZIP
      )}
    </>
  );

  const renderGetOtherContacts = () => {
    return (
      <>
        <Row>
          <Col xs="auto">
            <Form.Check
              {...haveDEROwnerField}
              type="checkbox"
              label={
                <Form.Text size="sm">
                  Is the DER System Owner different than the Customer?
                </Form.Text>
              }
              onChange={onDerOwnerChange}
              disabled={disableFields || isView}
            />
          </Col>
          {otherContactData?.[contactType.derOwner] && (
            <Col>
              <a
                className="order-grid-hyper"
                onClick={() => {
                  setShowContactModal({
                    show: true,
                    type: contactType.derOwner,
                    mode: 'edit',
                    data: otherContactData?.[contactType.derOwner],
                  });
                }}
              >
                View/Edit
              </a>
            </Col>
          )}
        </Row>
        <Row>
          <Col xs="auto">
            <Form.Check
              {...haveSecCustField}
              type="checkbox"
              label={
                <Form.Text size="sm">
                  Do you want to add a Secondary Customer Contact?
                </Form.Text>
              }
              onChange={onSecCustChange}
              disabled={disableFields || isView}
            />
          </Col>
          {otherContactData?.[contactType.secCust] && (
            <Col>
              <a
                className="order-grid-hyper"
                onClick={() => {
                  setShowContactModal({
                    show: true,
                    type: contactType.secCust,
                    mode: 'edit',
                    data: otherContactData?.[contactType.secCust],
                  });
                }}
              >
                View/Edit
              </a>
            </Col>
          )}
        </Row>
        <Row>
          <Col xs="auto">
            <Form.Check
              {...havePOIOwnerField}
              type="checkbox"
              label={
                <Form.Text size="sm">
                 Is the POI Property Owner contact information different than the POI Location?
                </Form.Text>
              }
              onChange={onPoiOwnerChange}
              disabled={disableFields || isView}
            />
          </Col>
          {otherContactData?.[contactType.poiOwner] && (
            <Col>
              <a
                className="order-grid-hyper"
                onClick={() => {
                  setShowContactModal({
                    show: true,
                    type: contactType.poiOwner,
                    mode: 'edit',
                    data: otherContactData?.[contactType.poiOwner],
                  });
                }}
              >
                View/Edit
              </a>
            </Col>
          )}
        </Row>
        <Row>
          <Col xs="auto">
            <Form.Check
              {...haveInsElecField}
              type="checkbox"
              label={
                <Form.Text size="sm">
                Would you like to provide a Licensed Inspector/Electrician contact?
                </Form.Text>
              }
              onChange={onInsElecChange}
              disabled={disableFields || isView}
            />
          </Col>
          {otherContactData?.[contactType.insElect] && (
            <Col>
              <a
                className="order-grid-hyper"
                onClick={() => {
                  setShowContactModal({
                    show: true,
                    type: contactType.insElect,
                    mode: 'edit',
                    data: otherContactData?.[contactType.insElect],
                  });
                }}
              >
                View/Edit
              </a>
            </Col>
          )}
        </Row>
      </>
    );
  };

  return (
    <Form noValidate onSubmit={handleSubmit(submitForm)}>
      {props?.showAccount && (
        <>
          <ConfirmCustomer
            confirmCustomer={confirmCustomer}
            setConfirmCustomer={setConfirmCustomer}
            setHavePendingEnroll={setHavePendingEnroll}
            customerData={customerData}
            resetCustomer={resetCustomer}
          />
          {showServerError && (
            <ServerErrorPopup
              mainErr={cusErr}
              onClose={() => {
                setShowserverError(false);
              }}
            />
          )}
          {havePendingEnroll && (
            <ShowPendingEnrollemnt
              customerData={customerData}
              setHavePendingEnroll={setHavePendingEnroll}
              resetCustomer={resetCustomer}
            />
          )}
          {(type === contactType.customer || type === contactType.service) && (
            <Row>
              <Form.Group controlId="prj_nm">
                <Form.Text size="sm" style={{ margin: '2px' }}>
                  Project Name{' '}
                  {type === contactType.customer ? `(Optional)` : ''}
                </Form.Text>
                <Form.Control
                  {...register(CNT_KEY.PRJ_NM)}
                  type="text"
                  placeholder="Enter project name"
                  maxLength="100"
                  isInvalid={errors[CNT_KEY.PRJ_NM]}
                  disabled={disableFields || isView}
                />
                {renderError(CNT_KEY.PRJ_NM)}
              </Form.Group>
              <hr style={{ marginTop: '10px' }} />
            </Row>
          )}
          <Row>
            <Col xs="auto">
              <Form.Text size="sm" style={{ margin: '2px' }}>
                Do you have a service with AEP ?
              </Form.Text>
            </Col>

            <Col xs="auto">
              <Form.Check
                {...haveAEPConField}
                type="radio"
                label={<Form.Text size="sm">Yes</Form.Text>}
                id="haveConnection"
                value={'yes'}
                defaultChecked={haveConnection == 'yes'}
                onChange={onAEPConChange}
                disabled={isView}
              />
            </Col>
            <Col xs="auto">
              <Form.Check
                {...haveAEPConField}
                type="radio"
                label={
                  <Form.Text size="sm" style={{ margin: '2px' }}>
                    No
                  </Form.Text>
                }
                id="haveConnection"
                value={'no'}
                defaultChecked={haveConnection == 'no'}
                onChange={onAEPConChange}
                disabled={isView}
              />
            </Col>
          </Row>
          {haveConnection == 'yes' ? (
            <>
              {/* SECTION FOR AEP USER */}
              <Row>
                <Col xs="auto">
                  <Form.Check
                    {...conTypeField}
                    type="radio"
                    label={<Form.Text size="sm">Account Number</Form.Text>}
                    id="accNo"
                    value="accNo"
                    onChange={onConTypeChange}
                    defaultChecked={connectionType == 'accNo'}
                    disabled={isView}
                  />
                </Col>
                <Col xs="auto">
                  <Form.Check
                    {...conTypeField}
                    type="radio"
                    label={
                      <Form.Text size="sm" style={{ margin: '2px' }}>
                        EZID Number
                      </Form.Text>
                    }
                    id="ezid"
                    value="ezId"
                    onChange={onConTypeChange}
                    defaultChecked={connectionType !== 'accNo'}
                    disabled={isView}
                  />
                </Col>
              </Row>
              <Form.Group controlId="selectedId">
                <Form.Text size="sm" style={{ margin: '2px' }}>
                  {connectionType == 'accNo' ? `Account Number` : `EZ id`}
                </Form.Text>
                <Form.Control
                  {...conIdField}
                  type="text"
                  disabled={isView}
                  placeholder={
                    connectionType == 'accNo'
                      ? `Enter account number`
                      : `Enter EZ id`
                  }
                  onChange={onConIdChange}
                  maxLength={connectionType == 'accNo' ? 10 : 17}
                  autoComplete="nope"
                  isInvalid={errors[CNT_KEY.CONID]}
                />
                {renderError(CNT_KEY.CONID)}
              </Form.Group>
              {type !== contactType.service && <hr />}
            </>
          ) : (
            <>
              {/* SECTION FOR NON AEP USER */}
              {props.showPosition && (
                <>
                  <b>Point of Interconnection Information</b>
                  <Row>
                    {showLatError && !noPosError && (
                      <Alert variant={`danger`}>
                        Please check the Latitiude and Longitude entered
                      </Alert>
                    )}
                    <Col>
                      <Form.Group controlId="lattitude">
                        <Form.Text size="sm" style={{ margin: '2px' }}>
                          GPS Latitude(N)
                        </Form.Text>
                        <Form.Control
                          {...latField}
                          type="text"
                          placeholder="Latitude"
                          maxLength={14}
                          isInvalid={errors[CNT_KEY.LAT]}
                          disabled={disableFields || isView}
                          onChange={onLatChange}
                          onBlur={onLatLongBlur}
                        />
                        {renderError(CNT_KEY.LAT)}
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group controlId="Longitude">
                        <Form.Text size="sm" style={{ margin: '2px' }}>
                          GPS Longitude (W)
                        </Form.Text>
                        <Form.Control
                          {...longField}
                          type="text"
                          placeholder="Longitude"
                          maxLength={15}
                          isInvalid={errors[CNT_KEY.LONG]}
                          disabled={disableFields || isView}
                          onChange={onLongChange}
                          onBlur={onLatLongBlur}
                        />
                        {renderError(CNT_KEY.LONG)}
                      </Form.Group>
                    </Col>
                    <Col>
                      <div style={{ marginTop: '18px' }}>
                        <StyledButton
                          btnType="secondary"
                          variant="dark"
                          size="md"
                          onClick={onViewAtMap}
                        >
                          View in Map
                        </StyledButton>
                      </div>
                    </Col>
                  </Row>
                  {showMap && (
                    <>
                      <hr />
                      <MapLocation
                        position={[
                          getValues(CNT_KEY.LAT),
                          getValues(CNT_KEY.LONG),
                        ]}
                      />
                      <hr />
                    </>
                  )}
                  <b>Nearest/Approximate address of Point of Interconnection</b>
                  {renderAddressForm(
                    CNT_KEY.ADD1,
                    CNT_KEY.ADD2,
                    CNT_KEY.STATE,
                    CNT_KEY.CITY,
                    CNT_KEY.ZIP
                  )}
                </>
              )}
            </>
          )}
        </>
      )}

      {!isProjectDetailsView && props.setPreviousData && (
        <>
          <Form.Group id="sameprevious">
            <Form.Check
              {...register(CNT_KEY.SAME_CD)}
              type="checkbox"
              label={
                <Form.Text size="sm">
                  Same as{' '}
                  {type === contactType.applicant ? `customer` : `applicant`}{' '}
                  details?
                </Form.Text>
              }
            />
          </Form.Group>
          <hr />
        </>
      )}
      {/* COMMON FORM HERE BELOW */}
      {showCommonForm && renderCommonForm()}
      {type === contactType.customer && renderGetOtherContacts()}
      {!isView && (
        <ButtonContainer>
          {!props.noBack && !isEdit && (
            <StyledButton
              btnType="secondary"
              variant="dark"
              size="md"
              onClick={() => {
                setSection(false);
              }}
            >
              Back
            </StyledButton>
          )}
          <StyledButton
            type="submit"
            btnType="primary"
            variant="dark"
            size="md"
          >
            {isEdit ? `Update` : `Next`}
          </StyledButton>
        </ButtonContainer>
      )}

      {/* RENDER MODALS BELOW */}
      {showContactModal?.show && (
        <ContactModal
          viewState={showContactModal}
          setViewState={setShowContactModal}
          resetField={resetModalField}
          saveContact={saveOtrContact}
        />
      )}
    </Form>
  );
}
